import MagazineTabs from "@scripts/magazine/MagazineTabs";

class ChannelList {
  private el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
  }

  public init() {
    new MagazineTabs(this.el);
  }
}

const components = {
  "channel-list": ChannelList
};

export function initComponents(root = document) {
  Object.entries(components).forEach(([name, Component]) => {
    root.querySelectorAll<HTMLElement>(`[data-component="${name}"]`).forEach(el => {
      new Component(el).init();
    });
  });
}
